import React from 'react'
import PropTypes from 'prop-types'
import { Container, Paragraph } from '@scentregroup/ui'
import Feature from '../../feature'
import FlipFlop from '../../flip-flop'
import Article from '../../article'
import Jenga from '../../jenga'
import FullWidth from '../../full-width'
import { HalfHalf, Half } from '../../half-half'
import Accordion from '../../accordion'
import { Deck, DeckCard } from '../../deck'
import FeaturedContent from '../../featured-content'
import PageHeading from '../../page-heading'
import SectionHeading from '../../section-heading'
import FilteredCardList from '../../filtered-card-list'
import style from '../../../components/container.scss'
import Promotion from '../../promotion'
import SocialFeed from '../../social-feed'
import Reviews from '../../reviews'
import CentreUtilityBox from '../../centre-utility-box'
import ComparisonItem from '../../comparison-item'
import { SpotlightModule } from '../../spotlight'
import { PromotionPositionContext } from '../../../context'

const Module = ({ moduleProps, lazyLoad }) => {
  switch (moduleProps.displayMode) {
    case 'Feature':
      return (
        <PromotionPositionContext.Provider
          value={moduleProps?.analyticsMetadata?.displayId}
        >
          <Feature
            lazyLoad={lazyLoad}
            {...moduleProps}
            analyticsMetadata={moduleProps.entryAnalyticsMetadata}
          />
        </PromotionPositionContext.Provider>
      )
    case 'UtilityPanel':
      return <CentreUtilityBox {...moduleProps} />
    case 'Flip Flop':
      return (
        <PromotionPositionContext.Provider
          value={moduleProps?.analyticsMetadata?.displayId}
        >
          <Container type="large" className={style.container}>
            <FlipFlop
              lazyLoad={lazyLoad}
              {...moduleProps}
              analyticsMetadata={moduleProps.entryAnalyticsMetadata}
            >
              <Article {...moduleProps}>
                <Paragraph>{moduleProps.body}</Paragraph>
              </Article>
            </FlipFlop>
          </Container>
        </PromotionPositionContext.Provider>
      )
    case 'Half Half (With Image)':
    case 'Half Half (Text Only)':
      return (
        <PromotionPositionContext.Provider
          value={moduleProps?.analyticsMetadata?.displayId}
        >
          <Container type="large" className={style.container}>
            <HalfHalf>
              {moduleProps.entries.map(entry => (
                <Half {...entry} key={entry.id} lazyLoad={lazyLoad} />
              ))}
            </HalfHalf>
          </Container>
        </PromotionPositionContext.Provider>
      )
    case 'Full Width (With Image)':
    case 'Full Width (Text Only)':
      return (
        <PromotionPositionContext.Provider
          value={moduleProps?.analyticsMetadata?.displayId}
        >
          <Container type="large" className={style.container}>
            <FullWidth
              lazyLoad={lazyLoad}
              {...moduleProps}
              analyticsMetadata={moduleProps.entryAnalyticsMetadata}
            />
          </Container>
        </PromotionPositionContext.Provider>
      )
    case 'Accordion':
      return (
        <Container type="large" className={style.container}>
          <Accordion {...moduleProps} />
        </Container>
      )
    case 'Featured Content':
      return (
        <PromotionPositionContext.Provider
          value={moduleProps?.analyticsMetadata?.displayId}
        >
          <FeaturedContent color={moduleProps.color} title={moduleProps.title}>
            {(moduleProps.entries || []).map(entry => (
              <DeckCard {...entry} key={entry.id} />
            ))}
          </FeaturedContent>
        </PromotionPositionContext.Provider>
      )
    case 'Jenga':
      return <Jenga {...moduleProps} />
    case 'Deck':
      return (
        <PromotionPositionContext.Provider
          value={moduleProps?.analyticsMetadata?.displayId}
        >
          <Deck {...moduleProps}>
            {(moduleProps.entries || []).map(entry => (
              <DeckCard {...entry} key={entry.id} />
            ))}
          </Deck>
        </PromotionPositionContext.Provider>
      )
    case 'Page Heading':
      return <PageHeading {...moduleProps} />
    case 'Section Heading':
      return <SectionHeading {...moduleProps} />
    case 'Promotion':
      return (
        <Container type="large" className={style.container}>
          <Promotion {...moduleProps} />
        </Container>
      )
    case 'FilteredCardList':
      return <FilteredCardList {...moduleProps} />
    case 'SocialFeed':
      return <SocialFeed {...moduleProps} />
    case 'CentreReviews':
      return <Reviews {...moduleProps} />
    case 'News':
      return (
        <PromotionPositionContext.Provider
          value={moduleProps?.analyticsMetadata?.displayId}
        >
          <SpotlightModule useAlternateDesign moduleProps={moduleProps} />
        </PromotionPositionContext.Provider>
      )
    case 'Comparison Item':
      return (
        <Container type="large" className={style.container}>
          <HalfHalf>
            {moduleProps.entries.map(entry => (
              <ComparisonItem {...entry} key={entry.productName} />
            ))}
          </HalfHalf>
        </Container>
      )
    case 'Spotlight':
    default:
      return (
        <PromotionPositionContext.Provider
          value={moduleProps?.analyticsMetadata?.displayId}
        >
          <SpotlightModule moduleProps={moduleProps} />
        </PromotionPositionContext.Provider>
      )
  }
}

Module.propTypes = {
  moduleProps: PropTypes.object,
  resetModulesTemplate: PropTypes.func,
  lazyLoad: PropTypes.bool,
}

Module.defaultProps = {
  lazyLoad: true,
}

export default Module
